import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";
import Profile from "./views/Profile.vue";
import CaseStudy from "./views/CaseStudy.vue";
import NotFound from "./views/NotFound.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "index",
            component: Index
        },
        {
            path: "/profile",
            name: "profile",
            component : Profile
        },
        {
            path : "/casestudy/:slug",
            name : "casestudy",
            component : CaseStudy
        },
        {
            path : '*',
            name : 'not-found',
            component : NotFound
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x : 0, y : 0 }
    }
});
